import { useState, useEffect, useCallback } from 'react';

interface ParallaxOptions {
  speed?: number;
  direction?: 'up' | 'down';
  enabled?: boolean;
}

export function useParallax(options: ParallaxOptions = {}) {
  const { speed = 0.5, direction = 'up', enabled = true } = options;
  const [offset, setOffset] = useState(0);
  const [opacity, setOpacity] = useState(1);

  const handleScroll = useCallback(() => {
    if (!enabled) return;
    
    const scrollY = window.scrollY;
    const multiplier = direction === 'up' ? -1 : 1;
    
    setOffset(scrollY * speed * multiplier);
    
    // Fade out as user scrolls
    const fadeStart = 100;
    const fadeEnd = 400;
    const newOpacity = Math.max(0, Math.min(1, 1 - (scrollY - fadeStart) / (fadeEnd - fadeStart)));
    setOpacity(scrollY < fadeStart ? 1 : newOpacity);
  }, [speed, direction, enabled]);

  useEffect(() => {
    if (!enabled) return;
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll, enabled]);

  return { offset, opacity };
}
